import React, { useEffect, useRef, useState } from "react";
import "./menudropdown.scss";
import ListIcons from "constants/Homepage/ysafe/menuList/listIconsFunc";
import SortIcons from "constants/Homepage/ysafe/iconFunctions/sortIcons";
import useScreenMobile from "hooks/useScreen";

const MenuDropDown = ({
  list,
  setMenu,
  setMobileRow = () => { },
  backgroundNone,
  row,
  setSelectedRow,
  subDropDown,
  setSubDropDown,
  tableMode,
  favorite,
  downloadFile,
  restoreFromTrash,
  DeleteFromTrash
}) => {
  const [clickedItem, setClickedItem] = useState(null); // Changed from hoveredItem to clickedItem for click behavior
  const [isPositionCalculated, setIsPositionCalculated] = useState(false); // Track if position is ready
  // const [dropdownPosition, setDropdownPosition] = useState({
  //   left: "-105px",
  //   right: "auto"
  // });
  // const [arrowRotation, setArrowRotation] = useState(
  //   tableMode === "table" ? "rotate(90deg)" : "rotate(-90deg)"
  // );

  const isMobile = useScreenMobile({ size: 992 });

  const dropdownRef = useRef(null);
  const subDropdownRef = useRef(null);
  const fileInfoItemRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setMobileRow();
        setMenu({
          selectedRow: null,
          selectedOption: ""
        });
        setClickedItem(null); // Close submenu when clicking outside
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  useEffect(() => {
    if (row) {
      setSelectedRow(row);
    }
  }, [row]);

  // useEffect(() => {
  //   if (subDropdownRef.current) {
  //     const dropdownRect = subDropdownRef.current.getBoundingClientRect();
  //     const screenWidth = window.innerWidth;

  //     if (dropdownRect.right > screenWidth) {
  //       setDropdownPosition({ left: "auto", right: "-105px" });
  //       setArrowRotation("rotate(90deg)");
  //       if (favorite) {
  //         setDropdownPosition({ left: "auto", right: "243px" });
  //         setArrowRotation("rotate(90deg)");
  //       }
  //     } else {
  //       setDropdownPosition({ left: "-105px", right: "auto" });
  //       if (favorite) {
  //         setDropdownPosition({ left: "243px", right: "auto" });
  //       }
  //     }
  //   }
  // }, [hoveredItem]);

  const [openToLeft, setOpenToLeft] = useState(false);

  // Calculate submenu position
  const calculateSubmenuPosition = () => {
    if (fileInfoItemRef.current && subDropdownRef.current) {
      // Get the parent item's position
      const parentRect = fileInfoItemRef.current.getBoundingClientRect();
      const screenWidth = window.innerWidth;

      // Get the submenu's actual width
      const submenuWidth = subDropdownRef.current.offsetWidth || 200; // fallback to 200px

      // Check if we're inside a scrollable table container that might clip us
      const tableContainer = dropdownRef.current.closest(".tableContainer");
      let boundaryRight = screenWidth;
      
      if (tableContainer) {
        const containerRect = tableContainer.getBoundingClientRect();
        boundaryRight = containerRect.right;
      }

      // Calculate space available on the right side within the viewport AND the container
      const spaceOnRight = Math.min(screenWidth, boundaryRight) - parentRect.right;

      // If not enough space on right, open to the left
      const shouldOpenLeft = spaceOnRight < submenuWidth + 30; // 30px buffer
      setOpenToLeft(shouldOpenLeft);
      setIsPositionCalculated(true); // Mark position as calculated
    }
  };

  useEffect(() => {
    if (clickedItem !== null) {
      setIsPositionCalculated(false); // Reset when opening
      // Small delay to ensure submenu is rendered and has dimensions
      const timer = setTimeout(() => {
        calculateSubmenuPosition();
      }, 10);

      return () => clearTimeout(timer);
    } else {
      setIsPositionCalculated(false); // Reset when closing
    }
  }, [clickedItem]);

  // Recalculate position on window resize
  useEffect(() => {
    if (clickedItem !== null) {
      window.addEventListener("resize", calculateSubmenuPosition);
      return () => {
        window.removeEventListener("resize", calculateSubmenuPosition);
      };
    }
  }, [clickedItem]);

  return (
    <div
      className="dropdownContainer"
      style={{
        background: backgroundNone && "transparent",
        boxShadow: backgroundNone && "none"
      }}
      ref={dropdownRef}
    >
      {list.map((item, index) => (
        <div
          key={index}
          className="content"
          ref={item.text === "File Information" ? fileInfoItemRef : null}
          onClick={() => {
            if (item.text !== "File Information") {
              if (item.text === "Download") {
                downloadFile();
              } else if (item.text === "Restore") {
                restoreFromTrash();
              } else if (item.text === "Delete forever") {
                DeleteFromTrash();
              }
              setMobileRow();
              setMenu((prev) => ({
                ...prev,
                selectedRow: null,
                selectedOption: item.text
              }));
            } else if (item.text === "File Information") {
              // Toggle submenu on click for both desktop and mobile
              setClickedItem(clickedItem === index ? null : index);
            }

          }}
        >
          <div className="item-info">
            <div className="icon">{item.icon}</div>
            <p className="text">{item.text}</p>
            {item.text === "File Information" && (
              <SortIcons type="arrow" color="var(--text-grey-strong)" />
            )}
          </div>

          {clickedItem === index &&
            item.text === "File Information" && (
              <div
                className="subdropdown"
                ref={subDropdownRef}
                style={{
                  position: "absolute",
                  top: 0,
                  left: openToLeft ? "auto" : "100%",
                  right: openToLeft ? "100%" : "auto",
                  zIndex: 10,
                  opacity: isPositionCalculated ? 1 : 0,
                  visibility: isPositionCalculated ? "visible" : "hidden",
                  transition: isPositionCalculated ? "opacity 0.15s ease-in-out" : "none"
                }}
                onClick={(e) => e.stopPropagation()} // prevents closing on click inside
              >
                <MenuDropDown
                  tableMode={tableMode}
                  setMenu={setMenu}
                  setMobileRow={setMobileRow}
                  backgroundNone={backgroundNone}
                  setSubDropDown={setSubDropDown}
                  subDropDown={subDropDown}
                  setSelectedRow={setSelectedRow}
                  list={[
                    { icon: <ListIcons type="details" />, text: "Details" },
                    { icon: <ListIcons type="activity" />, text: "Versions" }
                  ]}
                />
              </div>
            )}
        </div>
      ))}
    </div>
  );
};

export default MenuDropDown;
